import DataManager from '@americanexpress/data-manager';
import {
  AmexDDLRegister,
  getAmexDataManagerConfig,
} from '@americanexpress/data-manager-utils';
import SharedScript from '@americanexpress/shared-scripts';
import { node } from 'prop-types';
import React from 'react';

const AnalyticsWrapper = (props) => {
  const {
    children,
  } = props;

  if (!global.BROWSER) {
    return children;
  }

  return (
    <DataManager {...getAmexDataManagerConfig()}>
      <AmexDDLRegister />
      <SharedScript
        name="one-stream-data-handler"
        windowCheck="oneStreamData"
        version="^0.1.2"
      />
      {children}
    </DataManager>
  );
};

AnalyticsWrapper.propTypes = {
  children: node,
};

export default AnalyticsWrapper;
